import React, { Component } from "react";
import Hls from "hls.js";

// Main props are manifestURL: string, and timeUpdateCallback(timeMs: number)
export default class HLSPlayer extends Component {
  cb: Function;

  videoElementAdded(videoEl) {
    if (videoEl == null) {
      return;
    }

    this.videoEl = videoEl;

    const { manifestURL, timeUpdateCallback } = this.props;
    if (Hls.isSupported()) {
      let hls = new Hls({
        // debug: this.debug,
        xhrSetup: function(xhr, url) {
          xhr.withCredentials = false;
        }
      });
      hls.loadSource(manifestURL);
      hls.attachMedia(videoEl);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoEl.play();
      });

      this.cb = () => {
        timeUpdateCallback(videoEl.currentTime * 1000);
      };

      videoEl.addEventListener("timeupdate", this.cb);
    }
  }

  componentWillUnmount = () => {
    this.videoEl.removeEventListener("timeupdate", this.cb);
  };

  render() {
    return <video autoPlay controls ref={this.videoElementAdded.bind(this)} />;
  }
}



// WEBPACK FOOTER //
// ./src/VOD/Players/Vanilla.js